import WebSite from "../enums/WebSite";

let defaultType: WebSite | null = null;

// 获取 web 站点
const getWebSite = (url?: string): WebSite => {
  if (defaultType) return defaultType;

  const _url = url || (process.browser ? location.hostname : null) || WebSite.Akulaku;

  // aku流程 1 欧洲流程 2
  let type: WebSite = WebSite.Akulaku;

  Object.values(WebSite).forEach((key) => {
    if (_url.indexOf(key) > -1) {
      type = defaultType = key;
    }
  });

  return type;
};

export default getWebSite;
